'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyToggle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyToggle = exports.PrivacyToggle = function (_React$Component) {
  _inherits(PrivacyToggle, _React$Component);

  function PrivacyToggle() {
    _classCallCheck(this, PrivacyToggle);

    return _possibleConstructorReturn(this, (PrivacyToggle.__proto__ || Object.getPrototypeOf(PrivacyToggle)).apply(this, arguments));
  }

  _createClass(PrivacyToggle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* for testing goodness */}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isPrivate = _props.isPrivate,
          handlePrivacyToggle = _props.handlePrivacyToggle,
          showLabel = _props.showLabel;


      return _react2.default.createElement(
        _baseButtons.TextButton,
        { handleClick: handlePrivacyToggle, className: 'cp-privacy-toggle' },
        PrivacyToggle.renderIcon(isPrivate),
        showLabel ? PrivacyToggle.renderLabel(isPrivate) : null
      );
    }
  }], [{
    key: 'renderIcon',
    value: function renderIcon(isPrivate) {
      if (isPrivate) {
        return _react2.default.createElement(_baseIcons.Lock, null);
      }
      return _react2.default.createElement(_baseIcons.Unlock, null);
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(isPrivate) {
      if (isPrivate) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'private' });
      }
      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shared' });
    }
  }]);

  return PrivacyToggle;
}(_react2.default.Component);

PrivacyToggle.propTypes = {
  isPrivate: _react.PropTypes.bool.isRequired,
  showLabel: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired
};

exports.default = PrivacyToggle;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/privacy-toggle/components/PrivacyToggle.js
// module id = 1042
// module chunks = 4